'use client'

import { Popover, PopoverBackdrop, PopoverButton, PopoverPanel } from '@headlessui/react'
import _ from 'lodash'
import NextLink from 'next/link'
import { memo } from 'react'
import { createPortal } from 'react-dom'
import { HiChevronDown } from 'react-icons/hi'
import { infoPages } from '@/settings'
import { ToggleBodyScroll } from './toggleBodyScroll'

type Page = {
  name: string
  href: string
}

// Components
const InfoMenuItem = memo(({ page, onClick }: { page: Page; onClick: () => void }) => (
  <li>
    <NextLink hrefLang='en' href={page.href} className='menu-item block w-full' onClick={onClick}>
      {page.name}
    </NextLink>
  </li>
))

export const HeaderInfoMenu = memo(() => {
  return (
    <Popover as='div' className='relative'>
      {({ open, close }) => {
        // Safe check for browser environment before rendering portal
        const backdrop =
          open && typeof document !== 'undefined'
            ? createPortal(<PopoverBackdrop className='dialog-backdrop z-10!' onClick={close} />, document.body)
            : null

        return (
          <>
            <ToggleBodyScroll open={open} />
            {backdrop}
            <PopoverButton className='menu-button font-medium dark:font-normal' aria-label='About Us Menu'>
              <span>About Us</span>
              <HiChevronDown aria-hidden='true' className='-mr-2 ml-1 size-4' />
            </PopoverButton>
            <PopoverPanel
              as='nav'
              aria-label='About Us Submenu'
              anchor='bottom start'
              transition={true}
              modal={false}
              unmount={false}
              className='menu-items rounded-r-md pt-2 pb-4'
            >
              <ul className='m-0 flex w-full list-none flex-col p-0'>
                {_.map(infoPages, (page, idx) => (
                  <InfoMenuItem key={`navInfo_${idx}`} page={page} onClick={close} />
                ))}
              </ul>
            </PopoverPanel>
          </>
        )
      }}
    </Popover>
  )
})
